import { render, staticRenderFns } from "./ContactCommentsModal.vue?vue&type=template&id=5d1dad40&"
import script from "./ContactCommentsModal.vue?vue&type=script&lang=ts&"
export * from "./ContactCommentsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1dad40')) {
      api.createRecord('5d1dad40', component.options)
    } else {
      api.reload('5d1dad40', component.options)
    }
    module.hot.accept("./ContactCommentsModal.vue?vue&type=template&id=5d1dad40&", function () {
      api.rerender('5d1dad40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/ContactCommentsModal.vue"
export default component.exports